import React from 'react';
import styled from 'react-emotion';
import NotFoundPage from '../NotFoundPage';
// import { Query } from 'react-apollo';
// import gql from '@jetshop/core/gql';
import Image from '@jetshop/ui/Image';

import Layout from '../Layout/Layout';

const Header = styled('h1')`
  text-align: left;
  font-size: 22px;
  color: #444;
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

const Content = styled('div')`
  padding-bottom: 1rem;
  line-height: 1.6;

  p {
    margin-bottom: 10px;
    line-height: 1.6;
  }
`;

const ImageContainer = styled('div')`
  [data-flight-image-container] {
    padding-bottom: 37% !important;
  }
`;

const ContentPage = ({ result: { data } }) => {
  if (data && data.route && data.route.object && data.route.object.content) {
    const title = data.route.object.mainHeader || data.route.object.name;
    const image =
      data.route.object.images &&
      data.route.object.images.find(image => image.url.includes('original'));

    const breadcrumbProps = {
      breadcrumbText: data.route.object.breadcrumbText,
      parents: data.route.parents
    };

    return (
      <Layout breadcrumbs={breadcrumbProps} route={data.route} hideCategoryTree>
        <Header>{title}</Header>
        <ImageContainer>
          {image && <Image src={image.url} alt={title} />}
        </ImageContainer>
        <Content
          dangerouslySetInnerHTML={{ __html: data.route.object.content }}
        />
      </Layout>
    );
  } else {
    return <NotFoundPage />;
  }
};

export default ContentPage;
